<template>
    <v-app>
        <div class="divPorfesor">
            <div class="divResumenInfo">
                <v-avatar class="hidden-sm-and-down" width="200" height="200">
                    <img :src="img" alt="Lopez">
                </v-avatar>
                <v-img class="hidden-md-and-up" :src="img" alt="Lopez"></v-img>
                <br>
                <br>
                <span class="title">
                    <strong>Dr. Ulises Noel Gutiérrez Guzmán</strong>
                </span>
                <hr>
                <br>
                <div class="text-left">
                    <div>
                        <p>
                            <v-icon color="red">mdi-email-open</v-icon> jose_dimaslopez@hotmail.com
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div class="divSNI">
                        <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                        <b>SNI</b>
                        <v-spacer></v-spacer>
                        <b>NIVEL: </b> candidato
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <p>
                            <v-icon color="red">mdi-alpha-x-circle</v-icon>
                            <b>PROMEP</b>
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <b>CUERPO ACADEMICO</b>
                        <br>
                        <br>
                        <p>Desarrollo Agrícola Sustentable</p>
                    </div>
                </div>
                <br>
                <div>
                    <v-btn color="blue" text @click="insertarRuta('/conocenos/planta-academica/')">Regresar</v-btn>
                </div>
            </div>
            <div class="divEstudiosInfo" v-show="info">
                <div id="divAgrupaInfo">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>FORMACIÓN ACADEMICA</strong>
                        </span>
                    </div>
                    <div id="licenciatura">
                        <p>
                            <b>LICENCIATURA.</b>
                            <br>
                            INGENIERO AGRONOMO ZOOTECNISTA (1999)
                            <br>
                            <v-divider class="m-0"></v-divider>
                            UNIVERSIDAD JUÁREZ DEL ESTADO DE DURANGO
                        </p>
                        <br>
                        <p>
                            <b>MAESTRIA.</b>
                            <br>
                        <ul>
                            <li>MAESTRO EN CIENCIAS EN AGRICULTURA ORGÁNICA SUSTENTABLE (2001)</li>
                            <p>
                                DIVISIÓN DE ESTUDIOS DE POSGRADO FAZ-UJED.
                            </p>
                        </ul>
                        </p>
                        <br>
                        <p>
                            <b>DOCTORADO.</b>
                            <br>
                        <ul>
                            <li>DOCTORADO EN CIENCIAS AGROPECUARIAS Y FORESTALES (2015)</li>
                            <p>
                                DOCTORADO INSTITUCIONAL EN CIENCIAS AGROPECUARIAS Y FORESTALES
                                <br>
                                UJED
                            </p>
                        </ul>
                        </p>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>ÁREA DE CONOCIMIENTO.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon">
                        <ul>
                            <li>MANEJO Y CONSERVACIÓN DE RECURSOS NATURALES</li>
                        </ul>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>MÁS INFORMACIÓN.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon" class="pb-1">
                        <v-btn color="blue" @click="info = false; mostrarPublicaciones = true" text>Publicaciones</v-btn>
                        <br>
                        <v-btn color="blue" @click="info = false; mostrarProyectos = true" text>Proyectos</v-btn>
                    </div>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarPublicaciones == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PUBLICACIONES.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarPublicaciones = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headers" :items="Tabla" item-key="numero"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarProyectos == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PROYECTOS.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarProyectos = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headersProy" :items="tablaProyectos" item-key="nombre"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
        </div>
    </v-app>
</template>
<script>
//import datos from `./${personaje._id}`
//const datos = await import(`./${this.datosTabla}.json`);

export default {
    data() {
        return {
            img: require('@/assets/images/Planta Academica/gutierrez.jpg'),
            item: [],
            datos: null,
            publicaciones: false,
            info: true,
            mostrarPublicaciones: false,
            mostrarProyectos: false,
            headers: [
                {
                    text: 'No.',
                    align: 'start',
                    sortable: false,
                    value: 'numero',
                },
                { text: 'TÍTULO', value: 'titulo' },
                { text: 'AÑO PUBLICACIÓN', value: 'publicacion' },
            ],
            Tabla: [
                {
                    numero: 1,
                    titulo: 'Cuantificación del carbón orgánico del suelo en diferentes tipos de vegetación del noreste del estado de Durango. Agrofaz  18 (1): 81-90. Ulises Noel Gutiérrez-Guzmán, Erasmo Mixael Martínez-Flores, Miguel Pargas-Mendoza, Amaury Esquivel-Romo, Edmundo Castellanos-Pérez, Juan José Martínez-Ríos, Apolinar González-Mancilla. Revistas Arbitradas.',
                    publicacion: 2018,
                },
                {
                    numero: 2,
                    titulo: 'Satellite and field radiometry for the estimation of biomass production in a grassland site in state of Durango, Mexico. Range Mgmt. & Agroforestry 38 (2): 158-164. Ulises Noel Gutiérrez-Guzmán, Edmundo Castellanos-Perez, J. Santos Serrato-Corona, Juan José Martínez-Ríos and Isaías Chairez-Hernández. Revistas Indizadas.',
                    publicacion: 2017,
                },
                {
                    numero: 3,
                    titulo: 'Viabilidad de semilla de zacate banderita [Bouteloua curtipendula (Michx.) Torr.] cosechada en poblaciones naturales de municipio de Mapimí, Durango Agrofaz 17 (1): 115-122. Ulises Noel Gutiérrez-Guzmán, Andrea Minor-Hinojosa, Edmundo Castellanos-Pérez, Juan José Martínez-Ríos Amaury Esquivel-Romo. Revistas Arbitradas. Revistas Arbitradas.',
                    publicacion: 2017,
                },
                {
                    numero: 4,
                    titulo: 'Vegetal cover estimated by digital photographs related to biomass in a grassland site in northern Mexico. φYTON 84: 312-318. ISSN: 0031-9457, Ulises Noel Gutiérrez-Guzmán, Edmundo Castellanos-Pérez, Jesús José Quiñones-Vera, J. Santos Serrato-Corona, Juan José Martínez-Ríos, Ignacio Orona-Castillo, Isaías Chairez-Hernández, Phyton, Vol.84: 312-318, Revistas Indizadas.',
                    publicacion: 2015,
                },
            ],
            headersProy: [
                {
                    text: 'NOMBRE DEL PROYECTO',
                    align: 'start',
                    sortable: false,
                    value: 'nombre',
                },
                { text: 'TIPO DE FINANCIAMIENTO', value: 'tipo' },
            ],
            tablaProyectos: [
                {
                    nombre: 'Sistema de monitoreo terrestre orientado a la ganadería (SIMTOG).',
                    tipo: 'EXTERNO'
                },
                {
                    nombre: 'Programa de medidas para prevenir y enfrentar la sequía” en los consejos de cuenca nazas-aguanaval y del altiplano (PRONACOSE).',
                    tipo: 'EXTERNO'
                },
                {
                    nombre: 'Evaluación de grasa de sobrepaso en cabras lactantes y en desarrollo (OLEOFINOS).',
                    tipo: 'EXTERNO'
                },
                {
                    nombre: 'Cuantificación del carbón orgánico del suelo en diferentes sitios de pastizal y matorral del noreste del estado de Durango.',
                    tipo: 'EXTERNO'
                },
            ]
        }
    },
    methods: {
        insertarRuta(ruta) {
            this.$router.push(ruta);
        },
    },
}
</script>
